import { render, staticRenderFns } from "./ShopProductCart.vue?vue&type=template&id=4653cb11&scoped=true&"
import script from "./ShopProductCart.vue?vue&type=script&lang=js&"
export * from "./ShopProductCart.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductCart.vue?vue&type=style&index=0&id=4653cb11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4653cb11",
  null
  
)

export default component.exports